import React from "react";
import styled from "styled-components";

const StyledSpan = styled.span`
  position: relative;

&:before {
  content: '${props => props.n}';
  position: absolute;
  left: -3.125em;
  top: 0px;

      @media print {
      top: -11px;
    }
}
`;

export default ({ n, children }) => <StyledSpan n={n}>{children}</StyledSpan>;



// WEBPACK FOOTER //
// ./src/components/tekst/Linenumber.js